<template>
  <div>
    <table class="table table-responsive">
      <tbody>
        <tr>
          <th style="border-top: none">{{ $t('company_name') }}</th>
          <td style="border-top: none">
            {{ saveGet(licence, '-', 'licenseeName') }}
          </td>
        </tr>
        <tr v-if="saveGet(licence, '-', 'licenceKey').length < 12">
          <th>{{ $t('licensee_gln') }}</th>
          <td>{{ mainGln }}</td>
        </tr>
        <tr>
          <th>{{ $t('address') }}</th>
          <td>
            <Address
              :show-map="showMap"
              :address="saveGet(licence, null, 'address')"
            />
          </td>
        </tr>
        <tr>
          <th>{{ $t('website') }}</th>
          <td>
            <a v-if="website !== '-'" :href="website">
              {{ website }}
            </a>
            <span v-else>
              {{ website }}
            </span>
          </td>
        </tr>
        <tr>
          <th>{{ $t('license_key') }}</th>
          <td>{{ saveGet(licence, '-', 'licenceKey') }}</td>
        </tr>
        <tr>
          <th>{{ $t('license_type') }}</th>
          <td>{{ saveGet(licence, '-', 'licenceType') }}</td>
        </tr>
        <tr>
          <th>{{ $t('licensing_gs1_member_organisation') }}</th>
          <td style="border-bottom: none">
            {{ saveGet(licence, '-', 'licensingMO', 'moName') }}
          </td>
        </tr>
        <tr>
          <th>{{ $t('last_update') }}</th>
          <td style="border-bottom: none">{{ dateUpdated }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { saveGet } from '../mixins/saveGet'
import Address from './Address'
import moment from 'moment'

export default {
  name: 'Licence',
  props: ['licence', 'showMap', 'mainLicensesVerifiedResponse'],
  components: {
    Address
  },
  mixins: [saveGet],
  computed: {
    website() {
      return this.saveGet(this.licence, '-', 'contactPoint', 0, 'website')
    },
    dateUpdated() {
      let updated = this.saveGet(this.licence, '', 'dateUpdated')
      if (!updated) {
        return '-'
      }

      return moment(updated).format('DD. MMM YYYY')
    },
    mainGln() {
      if (
        this.mainLicensesVerifiedResponse === null ||
        this.licence.main === true
      ) {
        return this.saveGet(this.licence, '-', 'licenseeGLN')
      } else {
        return this.saveGet(
          this.mainLicensesVerifiedResponse,
          '-',
          'licenseeGLN'
        )
      }
    }
  },
  i18n: {
    messages: {
      de: {
        company_name: 'Firma',
        address: 'Adresse',
        website: 'Website',
        license_key: 'Lizenzschlüssel',
        license_type: 'Lizenztyp',
        licensing_gs1_member_organisation: 'Licensing GS1 Member Organisation',
        last_update: 'Zuletzt geändert',
        licensee_gln: 'Lizenznehmer GLN'
      },
      en: {
        company_name: 'Company Name',
        address: 'Address',
        website: 'Website',
        license_key: 'License Key',
        license_type: 'License Type',
        licensing_gs1_member_organisation: 'Licensing GS1 Member Organisation',
        last_update: 'Last update',
        licensee_gln: 'Licensee GLN'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Licence.vue